// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"274":"7316a5d1","556":"2d41d804","707":"d78ca7f8","774":"b22cf90f","850":"b8ecac73"}[chunkId] + ".chunk.css";
};